export default __webpack_public_path__ + "static/media/comment.24cdcaaf.svg";